module.exports = __webpack_public_path__ + "media/application/images/2024/shapes/11-f1fced000c640aaacbb4022c56b60501.png";